import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export interface User {
  id: number
  code: string
  name: string
  role: 'admin' | 'gm' | 'sales' | 'engineer' | 'finance' | 'hr' | 'warehouse' | 'purchasing' | 'quality' | 'maintenance' | 'supervisor' | 'worker' | 'guard' | 'iso'
  department: string
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const token = ref<string | null>(null)

  const isLoggedIn = computed(() => user.value !== null)

  function login(u: User, t: string) {
    user.value = u
    token.value = t
    try { sessionStorage.setItem('tn_session', JSON.stringify({ user: u, token: t })) } catch(_e) {}
  }

  function logout() {
    user.value = null
    token.value = null
    try { sessionStorage.removeItem('tn_session') } catch(_e) {}
  }

  function restoreSession() {
    try {
      const raw = sessionStorage.getItem('tn_session')
      if (!raw) return
      const data = JSON.parse(raw)
      if (data.user && data.token) {
        user.value = data.user
        token.value = data.token
      }
    } catch(_e) {}
  }

  return { user, token, isLoggedIn, login, logout, restoreSession }
})
